<template>
    <or-layout>
        <a-form layout="inline">
            <a-form-item>
                <a-select v-model="form.grade_id" placeholder="年级" style="width: 100px;" :loading="loading">
                    <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.subject" placeholder="科目" style="width: 100px;" :loading="loading">
                    <a-select-option v-for="(item) in subjectList" :key="item.id" :value="item.id">{{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-select v-model="form.exam_id" placeholder="考试科次" style="width: 420px;" :loading="loading">
                    <a-select-option v-for="(item) in examList" :key="item.id" :value="item.id">{{ item.exam_title }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" htmlType="submit" @click="getData">导入</a-button>
            </a-form-item>
        </a-form>
        <!-- <a-table :dataSource="data" :loading="loading" :rowKey="item => item.id" @change="onPaginationChange" bordered
            :pagination="pageinfo">

        </a-table> -->
    </or-layout>
</template>

<script>
export default {
    data() {
        return {
            gradeList: [
                { id: 'f0ba1a33ec3c05323e85a39bb351bf54', name: '二年级' },
                { id: 'a8d63f687cf09ff50c4d4b7cc090568c', name: '三年级' },
                { id: '389255d8b2d214fd2a7166f113b32848', name: '四年级' },
                { id: 'e2c94a56cae9c7b4c142816c80dd97ed', name: '五年级' },
                { id: '9a32bce9b4dce97eddd5c0f8861416fc', name: '六年级' },
            ],
            subjectList: [
                { id: 1, name: '数学' },
                { id: 2, name: '英语' },
                { id: 3, name: '语文' },
				 { id: 5, name: '物理' }
            ],
            form: {
                grade_id: 'f0ba1a33ec3c05323e85a39bb351bf54',
                subject: 1,
                exam_id: '12'
            },
            examList: [],
            loading: false,
            data: []
        }
    },
    created() {
        this.getExamInfoList();
        this.getGradeList();
        // this.getData()
    },
    methods: {
        getExamInfoList() {
            this.$axios.post("/api/StudentExam/get_exam_info_list").then(res => {
                this.loading = false;
                if (res.code != 200) {
                    this.$error({
                        title: "错误",
                        content: res.msg,
                        okText: "确定"
                    });
                } else {
                    this.examList = res.data;
                    if (this.examList.length > 0) {
                        this.form.exam_id = this.examList[0]['id'];
                    }
                }
            })
                .catch(err => {
                    console.error(err);
                });
        },
        onPaginationChange() {

        },
        getGradeList() {
            this.$axios.post("/api/BasicGrade/index").then(res => {
                if (res.code != 200) {
                    this.$error({
                        title: "错误",
                        content: res.msg,
                        okText: "确定"
                    });
                } else {
                    this.gradeList = res.data.data;
                }
            }).catch(err => {
                    console.error(err);
                });
        },
        getData() {
            this.$axios.post('/api/StudentExam/init_exam_student', {
                data: this.form
            }).then(res => {
                console.log(res);
            })
        },
    }
}
</script>
<style lang="less" scoped></style>